<template lang="pug">
.anchor_point
  .anchor_point_content
    .point_item(
      v-for="(item, i) in anchors",
      :key="i",
      @click="toScroll(item.id)"
    )
      img.logo(:src="item.logo")
      span.anchor_name {{ item.name }}
</template>

<script>
export default {
  data () {
    return {
      anchors: [
        {
          name: '行业事件', id: '#IndustryEvent', logo: require('@index/assets/anchor_industry.png')
        }, {
          name: '风险库', id: '#RiskLibrary', logo: require('@index/assets/anchor_industry.png')
        }, {
          name: '危机图谱', id: '#CrisisEcharts', logo: require('@index/assets/anchor_chart.png')
        }, {
          name: '危机对比', id: '#RiskContrast', logo: require('@index/assets/anchor_contrast.png')
        }
      ]
    }
  },
  watch: {
  },
  methods: {
    toScroll (id) {
      document.querySelector(id).scrollIntoView(true)
    }
  }
}
</script>

<style lang="scss" scoped>
.anchor_point {
  z-index: 2;
  width: 100%;
  background: #fff;
  .anchor_point_content {
    height: 70px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 1240px;
    margin: 0 auto;
    .point_item {
      padding: 0 65px;
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;
      user-select: none;
      .logo {
        width: 28px;
        height: 28px;
      }
      .anchor_name {
        margin-left: 23px;
        font-size: 16px;
        color: #333;
        font-weight: bold;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/index/EventIndex/HomePage/components/AnchorPoint.vue